import { fetchWithExponentialBackoff } from 'infrastructure/api'

export function isRateLimitError(error: unknown): boolean {
  if (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof (error as { message: unknown }).message === 'string'
  ) {
    return (error as { message: string }).message.includes(
      'User rate limit exceeded.',
    )
  }
  return false
}

export async function batchRequest(
  token: string,
  batchBody: string,
  boundary: string,
) {
  return fetchWithExponentialBackoff(
    'https://www.googleapis.com/batch/drive/v3',
    {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': `multipart/mixed; boundary=${boundary}`,
      },
      body: batchBody,
    },
    isRateLimitError,
    10, // max retries
    20_000, // rate limits reset every minute, so start with 20s delay
    1.1, // increase delay slowly
  )
}
